import { Tile } from '../tiles';
import { bestDiscard } from './ukeire';
import { riichiOpponents, safestDiscard } from './defense';
import { Policy } from '../game/playHand';
import { GameState, GameAction } from '../game/types';

export interface StrategyOptions {
  /** 수비 강도. 0=수비 안 함(항상 전진), 1~3=리치 상대가 있을 때 베타오리 적극도.
   *  폴드 임계 = 4 - defenseLevel (버림 후 샹텐이 이 값 이상이면 베타오리):
   *  L1=샹텐≥3, L2=샹텐≥2, L3=샹텐≥1(텐파이일 때만 푸시). 기본 0(기존 동작 보존). */
  defenseLevel?: number;
}

/** 샹텐/우케이레 기반 전략 정책(+선택적 수비). */
export function strategyPolicy(options: StrategyOptions = {}): Policy {
  const defenseLevel = options.defenseLevel ?? 0;

  return (state: GameState, seat: number, actions: GameAction[]): GameAction => {
    // 1. 화료 우선
    const win = actions.find((a) => a.type === 'tsumo' || a.type === 'ron');
    if (win) return win;

    // 2. response 단계: 화료 없으면 패스
    if (state.phase === 'response') {
      const pass = actions.find((a) => a.type === 'pass');
      if (pass) return pass;
    }

    // 3. draw 단계
    const draw = actions.find((a) => a.type === 'draw');
    if (draw) return draw;

    // 4. discard 단계
    if (state.drawn !== null) {
      const hand14: Tile[] = [...state.players[seat].hand, state.drawn];
      const eff = bestDiscard(hand14); // 효율 최선 버림 + 버림 후 샹텐

      // 수비 판단: 리치 상대가 있고(내가 리치 안 했고) 손패가 멀면 베타오리.
      const riichiSeats = riichiOpponents(state, seat);
      const shouldFold =
        defenseLevel > 0 &&
        riichiSeats.length > 0 &&
        !state.players[seat].riichi &&
        eff.shanten >= 4 - defenseLevel;
      if (shouldFold) {
        const safe = safestDiscard(hand14, state, riichiSeats);
        const safeDiscard = actions.find((a) => a.type === 'discard' && a.tile === safe);
        if (safeDiscard) return safeDiscard; // 안전패 버림(리치 선언하지 않음)
      }

      // 평소: 효율 최선 버림(리치 가능하면 리치)
      const riichi = actions.find((a) => a.type === 'riichi' && a.tile === eff.tile);
      if (riichi) return riichi;
      const discard = actions.find((a) => a.type === 'discard' && a.tile === eff.tile);
      if (discard) return discard;
    }

    // 폴백: 첫 합법 수
    return actions[0];
  };
}
